import React, { useEffect, useState } from "react";
import Navbar from "../../components/navbar/navbar";
import "./resume-page.css";
import SiteVisitedEvent from "../../components/siteVisitEvent/site-visited-event";

function ResumePage() {
  const [initialLoad, setInitialLoad] = useState(true);
  const [resumeUrl, setResumeUrl] = useState(null);

  useEffect(() => {
    if (initialLoad) {
      setInitialLoad(false);
      fetch("https://api.filefreak.io/public-list/ki1a-3m7s-1fen-mphc-ey3b-xg0o-th80-020q-t9wd/Documents/Resume/PortfolioSite")
        .then((res) => res.json())
        .then((data) => {
          if (data.success && data.objects && data.objects.length > 0) {
            const pdf = data.objects.find((obj) => obj.objectName.endsWith(".pdf"));
            if (pdf) {
              return fetch(`https://api.filefreak.io/get-file/${pdf.id}`);
            }
          }
          throw new Error("PDF not found in directory stream.");
        })
        .then((res) => {
          if (!res.ok) throw new Error("Failed to fetch PDF binary.");
          return res.blob();
        })
        .then((blob) => {
          const objectUrl = window.URL.createObjectURL(blob);
          setResumeUrl(objectUrl);
        })
        .catch((err) => console.error("Error fetching dynamic resume:", err));
    }
  }, [initialLoad]);

  return (
    <>
      <SiteVisitedEvent initialLoad={initialLoad} page={"Resume"} />
      <Navbar />
      <section id="ResumePage">
        <div className="spacer"></div>
        {resumeUrl ? (
          <iframe src={resumeUrl} type="application/pdf" title={"Resume"} frameBorder={0} scrolling="no!important" height={"150vh"}></iframe>
        ) : (
          <div style={{ height: "150vh", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: "20px" }}>
            <div style={{
              width: "50px",
              height: "50px",
              border: "4px solid rgba(150, 150, 150, 0.2)",
              borderTopColor: "var(--tertiary)",
              borderRadius: "50%",
              animation: "spin 1s linear infinite"
            }}></div>
            <style>
              {`
                 @keyframes spin {
                   to { transform: rotate(360deg); }
                 }
               `}
            </style>
            <h3 style={{ color: "var(--textPrimary)", fontFamily: "Inter, sans-serif" }}>Securely Retrieving Resume...</h3>
          </div>
        )}
        <div className="spacer"></div>
      </section>
    </>
  );
}

export default ResumePage;
